var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortingEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_563_1791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.91421 6L10.0858 6C10.9767 6 11.4229 4.92286 10.7929 4.29289L7.98995 1.48995C7.44322 0.943214 6.55678 0.943216 6.01005 1.48995L3.20711 4.29289C2.57714 4.92286 3.02331 6 3.91421 6Z",
    fill: "#97A0A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0858 8L3.91421 8C3.0233 8 2.57714 9.07714 3.2071 9.7071L6.01003 12.51C6.55677 13.0568 7.4432 13.0568 7.98993 12.51L10.7929 9.70711C11.4228 9.07714 10.9767 8 10.0858 8Z",
    fill: "#97A0A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_563_1791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortingEmpty);
export default __webpack_public_path__ + "static/media/SortingEmpty.284dd00f5aff4606101edef04804cde7.svg";
export { ForwardRef as ReactComponent };